const BLUE = "#4A7DB8";
const NAVY = "#0B2650";

export const MonogramPaths = ({ color = BLUE }) => (
  <g>
    <path d="M10 74 V9 L40 42 L69 9 H88 C113 9 113 45 88 45 H63" fill="none" stroke={color} strokeWidth="13" strokeLinejoin="round" strokeLinecap="round" />
    <path d="M49.5 53 L62.5 40.5 V74 H49.5 Z" fill={color} />
  </g>
);

export const Monogram = ({ size = 40, color = BLUE, className = "" }) => (
  <svg viewBox="0 0 112 82" width={size * (112 / 82)} height={size} className={className} aria-hidden>
    <MonogramPaths color={color} />
  </svg>
);

export const Logo = ({ height = 52, variant = "default", className = "" }) => {
  const white = variant === "white";
  return (
    <svg viewBox="0 0 800 82" height={height} width={(height * 800) / 82} className={`mp-logo ${className}`} role="img" aria-label="Military Police" data-testid="mp-logo">
      <MonogramPaths color={white ? "#fff" : BLUE} />
      <text x="128" y="61" fontFamily="Montserrat, Arial, sans-serif" fontWeight="800" fontSize="56" letterSpacing="2" fill={white ? "#fff" : NAVY}>MILITARY POLICE</text>
    </svg>
  );
};
